import { InputAdornment } from "@mui/material";
import MaterialUI from "material-UI";
import ModalFulscreen from "components/ModalFullscreen";
import EspelhoVendasModal from "components/dialogCommon/templates/EspelhoVendasModal";
import { useEffect, useState } from "react";
import { useListarTorres } from "services/api";
import { useParams } from "react-router-dom";
import * as S from "./styles";

interface Data {
  nomeEmpreendimento: string;
  torre: string;
  unidade: string;
  valorTabela: number;
  valorAvaliacao: number;
  enquadramento: string;
  metragem: string;
  tipologia: string;
  tipologia2: string;
  vagasGaragem: string;
  vagasMoto: string;
  codigoSap: string;
  bandeiraNome: string;
  bandeiraId: string;
  idEmpreendimento: string;
}

interface Props {
  dataDadosUnidade: Data;
  isLoadingDadosUnidade: boolean;
}

export default function DadosDaUnidade(props: Readonly<Props>) {
  const params: any = useParams();
  const [espelhoVendasModal, setEspelhoVendasModal] = useState(false);
  const [block, setBlock] = useState<any>([] || null);

  const { data: blocosData, refetch: blocosRefetch } = useListarTorres({
    idEmpreendimento: props?.dataDadosUnidade?.idEmpreendimento,
    queryKey: "listar-blocos",
  });

  useEffect(() => {
    if (blocosData && props?.dataDadosUnidade) {
      const findActualBlock = blocosData?.data?.find(
        (block: any) => block?.nome === props.dataDadosUnidade?.torre
      );
      setBlock(
        findActualBlock
          ? { value: findActualBlock?.id, label: findActualBlock?.nome }
          : { value: "", label: "" } // Garantir que seja um objeto vazio
      );
    }
  }, [blocosData, props?.dataDadosUnidade]);

  useEffect(() => {
    if (!props?.dataDadosUnidade) return;
    blocosRefetch();
    setBlock([]);
  }, [props?.dataDadosUnidade]);

  const newData: any = {
    bandeira: props.dataDadosUnidade?.bandeiraNome || { value: "", label: "" },
    produto: {
      value: props?.dataDadosUnidade?.idEmpreendimento || "",
      label: props?.dataDadosUnidade?.nomeEmpreendimento || "",
      codigoSap: props?.dataDadosUnidade?.codigoSap || "",
    },
    bloco: block || { value: "", label: "" },
    blocosData,
  };

  return (
    <>
      <S.Container>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <S.Title>Dados da Unidade</S.Title>
          {props.isLoadingDadosUnidade && (
            <MaterialUI.CircularProgress style={{ color: "blue" }} size={22} />
          )}
        </div>
        <S.BodyContainer>
          <S.Row>
            <S.Column>
              <S.TitleInfo>Empreendimento</S.TitleInfo>
              <S.TextField
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                disabled
                fullWidth
                value={props?.dataDadosUnidade?.nomeEmpreendimento}
              />
            </S.Column>
          </S.Row>
          <S.Row>
            <S.Column>
              <S.TitleInfo>Torre</S.TitleInfo>
              <S.TextField
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                disabled
                fullWidth
                value={props?.dataDadosUnidade?.torre}
              />
            </S.Column>
            <S.Column>
              <S.TitleInfo>Unidade</S.TitleInfo>
              <S.TextField
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                disabled
                fullWidth
                value={props?.dataDadosUnidade?.unidade}
              />
            </S.Column>
          </S.Row>
          <S.Row>
            <S.Column>
              <S.TitleInfo>Valor de Tabela (T1)</S.TitleInfo>
              <S.TextField
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                disabled
                fullWidth
                value={props?.dataDadosUnidade?.valorTabela.toLocaleString(
                  "pt-br",
                  {
                    minimumFractionDigits: 2,
                  }
                )}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">R$</InputAdornment>
                  ),
                  inputProps: {
                    style: { textAlign: "right" },
                  },
                }}
              />
            </S.Column>
            <S.Column>
              <S.TitleInfo>Valor de avaliação</S.TitleInfo>
              <S.TextField
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                disabled
                fullWidth
                value={props?.dataDadosUnidade?.valorAvaliacao.toLocaleString(
                  "pt-br",
                  {
                    minimumFractionDigits: 2,
                  }
                )}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">R$</InputAdornment>
                  ),
                  inputProps: {
                    style: { textAlign: "right" },
                  },
                }}
              />
            </S.Column>
          </S.Row>
          <S.Row>
            <S.Column>
              <S.TitleInfo>Enquadramento</S.TitleInfo>
              <S.TextField
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                disabled
                fullWidth
                value={props?.dataDadosUnidade?.enquadramento}
              />
            </S.Column>
            <S.Column>
              <S.TitleInfo>Metragem</S.TitleInfo>
              <S.TextField
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                disabled
                fullWidth
                value={props?.dataDadosUnidade?.metragem}
              />
            </S.Column>
          </S.Row>
          <S.Row>
            <S.Column>
              <S.TitleInfo>Tipologia</S.TitleInfo>
              <S.TextField
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                disabled
                fullWidth
                value={props?.dataDadosUnidade?.tipologia2}
              />
            </S.Column>
            <S.Column>
              <S.TitleInfo>Vagas de Garagem</S.TitleInfo>
              <S.TextField
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                disabled
                fullWidth
                value={props?.dataDadosUnidade?.vagasGaragem}
              />
            </S.Column>
            <S.Column>
              <S.TitleInfo>Vagas de Moto</S.TitleInfo>
              <S.TextField
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                disabled
                fullWidth
                value={props?.dataDadosUnidade?.vagasMoto}
              />
            </S.Column>
          </S.Row>
          {params.action === "editable" ? null : (
            <S.Row>
              <S.Column>
                <S.Button
                  onClick={() => setEspelhoVendasModal(true)}
                  disabled={props.isLoadingDadosUnidade}
                >
                  Espelho de vendas
                </S.Button>
              </S.Column>
            </S.Row>
          )}
        </S.BodyContainer>
      </S.Container>
      <ModalFulscreen
        open={espelhoVendasModal}
        setOpenModal={() => setEspelhoVendasModal(true)}
        onClose={() => setEspelhoVendasModal(false)}
      >
        <EspelhoVendasModal
          data={newData}
          onClose={() => setEspelhoVendasModal(false)}
          idLead={params.idLeadCorretor}
          openOpportunityForm={() => {}}
        />
      </ModalFulscreen>
    </>
  );
}
